var zoom = 100;
var maxZoom = 200;
var minZoom = 60;
var zoomIncrement = 20;
var fontSize = 16;

export function goToPage(){
  window.open('https://centroderelevo.gov.co/', '_blank');
}

//theme change
export function changeTheme(className) {
    if ($("body").attr("class") == className) {
        $("body").removeClass(className);
    } else {
        $("body").attr("class", className);
    }
}

export function resizeFont(scale) {
    if (scale == "+" && zoom <= maxZoom) {
        zoom += zoomIncrement;
        $("html").css("font-size", (fontSize * (zoom/100)) + "px");
    }
    if (scale == "-" && zoom >= minZoom) {
        zoom -= zoomIncrement;
        $("html").css("font-size", (fontSize * (zoom/100)) + "px");
      }
      if (scale == "0") {
        location.reload();
    }
    }

